<p-dialog
  [(visible)]="isShowCreateFeedback"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <p-header>
    <span *ngIf="!isEdit">New Feedback:</span>
    <span *ngIf="isEdit">Edit Feedback:</span>
    <span>Job {{ jobNumber }}</span>
  </p-header>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12">
      <div class="ui-g-3">Order</div>
      <div class="ui-g-9">
        <p-dropdown
          [options]="orders"
          placeholder="Select Order"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedOrder"
          (ngModelChange)="selectedOrderChanged()"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-3">Task</div>
      <div class="ui-g-9">
        <p-dropdown
          [options]="tasks"
          placeholder="Select Task"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedTask"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-3">Reason</div>
      <div class="ui-g-9">
        <p-dropdown
          [options]="types"
          placeholder="Select Type"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedType"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-3">Details</div>
      <div class="ui-g-9"></div>
    </div>
    <div class="ui-g-12" style="margin-top: 10px">
      <div class="ui-g-12">
        <textarea
          pInputTextarea
          [rows]="7"
          [cols]="40"
          [(ngModel)]="feedbackMessage"
          [maxlength]="1024"
          style="width: 100%"
          placeholder="Add details of feedback"
        ></textarea>
      </div>
    </div>
    <div class="ui-g-12" style="height: 50px; margin-top: 30px">
      <div class="ui-g-12">
        <button
          type="button"
          pButton
          icon="fa ui-icon-close"
          label="Cancel"
          class="ui-button btn-to-right"
          (click)="close()"
        ></button>
        <button
          type="button"
          pButton
          icon="fa ui-icon-check"
          label="Submit"
          class="ui-button green-btn btn-to-right"
          (click)="submit()"
          [disabled]="
            feedbackMessage.trim().length == 0 ||
            jobNumberError ||
            loadUserError ||
            !selectedType ||
            loadTypesError ||
            !selectedOrder ||
            !selectedTask
          "
        ></button>
      </div>
    </div>
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isBusySubmit || isBusyLoadJob || isBusyLoadUser"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>
</p-dialog>
